module.exports = __webpack_public_path__ + "img/selected0-min.d1afed81.png";